import type { TopBarProfileStatusButtonProps } from './types';
import arrowDown from 'Assets/images/arrow-down-icon.svg';
import { UserAvatar } from 'Components/shared/UserAvatar';
import { MobXProviderContext, observer } from 'mobx-react';
import { PresenceModel } from 'Models/index';
import React from 'react';
import { Popup } from 'semantic-ui-react';
import type { RootStoreProps } from 'Stores/RootStore.types';

export const TopBarProfileStatusButton: React.FC<TopBarProfileStatusButtonProps> =
  observer(({ displayName, displayAvatar, testid }) => {
    const {
      ui: { selectPersonMessageStatus, presenceById },
      person: { loggedInPersonId },
    } = React.useContext<RootStoreProps>(MobXProviderContext);
    const [loggedInPersonPresence, setLoggedInPersonPresence] =
      React.useState<PresenceModel>(
        PresenceModel.CreateOffLineStatus(loggedInPersonId.toString())
      );

    React.useEffect(() => {
      setLoggedInPersonPresence(presenceById?.get(loggedInPersonId.toString()));
    }, [presenceById?.get(loggedInPersonId.toString())?.state]);

    const { title = '', message = '' } = selectPersonMessageStatus(
      loggedInPersonId.toString()
    );

    return (
      <div
        className="user-name-wrap-inner"
        data-testid={`${testid}-buttonProfileStatus`}
      >
        <UserAvatar
          name={displayName}
          size={32}
          {...(loggedInPersonPresence?.state !== 'OffLine' && {
            presence: loggedInPersonPresence,
          })}
          image={displayAvatar}
        />
        <Popup
          inverted
          trigger={title && <span className="message-status">{title}</span>}
          content={message}
          position="bottom right"
        />
        <img src={arrowDown} className="down-arrow" />
      </div>
    );
  });
